import { useStaticQuery, graphql } from 'gatsby'

export const useAkutrutanQuery = () => {
  const data = useStaticQuery(graphql`
    {
      allWpAkutrutanSetting(limit: 5, sort: { date: DESC }) {
        edges {
          node {
            id
            date
            modified
            AkutrutanSettings {
              color
              datePicker
              fieldGroupName
              infoText
              pageLink {
                target
                title
                url
              }
              showAkutrutan
              pageLinkCheckbox
            }
          }
        }
      }
    }
  `)
  return data
}
